import React, { useEffect } from "react";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import {
  updateServerBreadcrumb,
  updateIdServerSelected,
  updateNameServerSelected,
} from "../../../redux/servers/serverSlice";
import {
  updateIdBankSelected,
  updateNameBankSelected,
  updateBankBreadcrumb,
} from "../../../redux/banks/bankSlice";
// COMPONENTS
import LiftsHeader from "./LiftsHeader";
import LiftsTable from "./LiftsTable";
import LiftsDrawer from "./LiftsDrawer";
import LiftsDeleteModal from "./LiftsDeleteModal";
import LiftsActivateDeactivate from "./LiftsActivateDeactivate";
import LiftsConfiguration from "./LifstConfiguration";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const LiftsPage = () => {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    dispatch(updateServerBreadcrumb([]));
    dispatch(updateBankBreadcrumb([]));
    dispatch(updateIdServerSelected(""));
    dispatch(updateIdBankSelected(""));
    dispatch(updateNameBankSelected(""));
    dispatch(updateNameServerSelected(""));
  }, []);
  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {hasPermission(Permission.ViewEdgeManagementLifts, permissionSet ?? []) ? (
        <div>
          <div className={`layout__contentPage__${theme}`}>
            <LiftsHeader />
            <LiftsTable />
            <LiftsDrawer />
            <LiftsDeleteModal />
            <LiftsActivateDeactivate />
            <LiftsConfiguration />
          </div>
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default LiftsPage;
